import { RootState } from "../reducers"

export const selectDonationHistory = (state: RootState) =>
  state.donation.donationsHistory

export const selectIsDonationHistoryFetching = (state: RootState) =>
  state.donation.isDonationHistoryFetching
